import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from '@/components/button';
import { SCREEN_PADDING } from '@/styles';
import { StyleSheet, View } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  children: React.ReactNode;
  isSaveDisabled?: boolean;
  isSaving: boolean;
  onSavePress: () => void;
  saveButtonTrackingData: TrackingData;
}

export const FulfillmentActionSheetViewContainer: React.FC<Props> = ({
  children,
  isSaveDisabled = false,
  isSaving,
  onSavePress,
  saveButtonTrackingData,
}) => {
  const { isSmallLayout } = useLayoutContext();
  return (
    <View collapsable={false} style={isSmallLayout ? null : styles.baseLarge}>
      {children}
      <Button
        containerStyle={[
          styles.saveButtonContainer,
          isSmallLayout
            ? styles.saveButtonContainerSmall
            : styles.saveButtonContainerLarge,
        ]}
        disabled={isSaveDisabled}
        loading={isSaving}
        onPress={onSavePress}
        size="large"
        testID="fulfillment-save-button"
        trackingData={saveButtonTrackingData}
      >
        {i18n.t('save')}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  baseLarge: {
    marginHorizontal: SCREEN_PADDING,
  },
  saveButtonContainer: {
    marginHorizontal: SCREEN_PADDING,
  },
  saveButtonContainerLarge: {
    marginHorizontal: 0,
    marginTop: 32,
  },
  saveButtonContainerSmall: {
    marginVertical: 32,
  },
});
